import { type SupportedIntegrationSyncTypes } from '#shared/lib/integrations';
import { showError } from '#shared/lib/toast';
import { deleteIntegrationSettings as deleteIntegrationSettingsApi } from '../api';

export const deleteIntegrationSettingsWithRefetch = async ({
    syncType,
    refetch,
    onAfterDelete,
}: {
    syncType: SupportedIntegrationSyncTypes | undefined;
    refetch?: VoidFunction;
    onAfterDelete?: VoidFunction;
}) => {
    if (!syncType) {
        return;
    }

    try {
        await deleteIntegrationSettingsApi(syncType);

        onAfterDelete?.();

        await refetch?.();
    } catch (error) {
        showError({ label: 'Произошла ошибка при удалении источника, попробуйте еще раз.' }, error);
    }
};
